import { render, staticRenderFns } from "./yearlyFxRates.vue?vue&type=template&id=cfe697dc"
import script from "./yearlyFxRates.vue?vue&type=script&lang=js"
export * from "./yearlyFxRates.vue?vue&type=script&lang=js"
import style0 from "./yearlyFxRates.vue?vue&type=style&index=0&id=cfe697dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports